import { toast } from "react-toastify";
import { logOut, logOut401 } from "../config/user";

let isSessionExpiredAlertShown = false;

export const handleApiErrorResponses = (error) => {
  if (error.response) {
    const { status, statusText, data } = error.response;
    switch (status) {
      case 401:
        if (!isSessionExpiredAlertShown) {
          isSessionExpiredAlertShown = true;
          logOut401();
          window.alert(
            "You've been logged out because this session was removed from another device. Please log in again to continue.",
          );
        }
        break;

      case 420:
        let customMessage =
          data?.error || data?.message || "Something went wrong.";
        // showCustomAlert(customMessage);
        // window.alert(customMessage);
        toast.error(customMessage);
        break;
      case 409:
        // showCustomAlert(customMessage);
        window.alert(data?.error || data?.message);
        break;
      case 403: // Forbidden
        data?.error
          ? window.alert(data?.error)
          : window.alert("You don't have permission to access this resource.");
        break;

      case 500: //Internal Server Error
        window.alert(
          "An unexpected server error occurred. Please try again later.",
        );
        break;

      default:
        console.error(`Unhandled API error: ${status} - ${statusText}`);
        break;
    }
  } else {
    console.error("Error without response:", error);
  }
};
